import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-solucion',
  templateUrl: './solucion.component.html',
  styleUrls: ['./solucion.component.css']
})
export class SolucionComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
